import { render, staticRenderFns } from "./PercentagePointDelta.vue?vue&type=template&id=3fdd2ba6&scoped=true"
import script from "./PercentagePointDelta.vue?vue&type=script&lang=js"
export * from "./PercentagePointDelta.vue?vue&type=script&lang=js"
import style0 from "./PercentagePointDelta.vue?vue&type=style&index=0&id=3fdd2ba6&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdd2ba6",
  null
  
)

export default component.exports